<script>
  import { Menu, MenuItem } from "@gl/design-system"
  import { navigate } from "../utils/index"
  import { navigate as navigateSvelte } from "svelte-routing"
  import { _, user } from "../stores/index"
  import { getContext } from "svelte"
  const { isAuthorized } = getContext("isAuthorized")
  import { faUser, faHatCowboy, faUsers, faTh, faHouse, faGrid, faTableRows } from "@fortawesome/pro-regular-svg-icons"

  export let selected
</script>

<div class="main">
  <div class="flex-menu theme-dark">
    <div class="menu">
      <Menu>
        {#if $isAuthorized("user_read")}
          <MenuItem
            selected={selected.startsWith("users")}
            on:click={() => navigate("/users")}
            on:keydown={(e) => e.key === "Enter" && navigate("/users")}
            icon={faUser}
          >
            <div class="label">
              {$_("common.users")}
            </div>
          </MenuItem>
        {/if}

        {#if $isAuthorized("role_read")}
          <MenuItem
            selected={selected.startsWith("roles")}
            on:click={() => navigate("/roles")}
            on:keydown={(e) => e.key === "Enter" && navigate("/roles")}
            icon={faHatCowboy}
          >
            <div class="label">
              {$_("common.roles")}
            </div>
          </MenuItem>
        {/if}

        {#if $isAuthorized("group_read")}
          <MenuItem
            selected={selected === "groups"}
            on:click={() => navigate("/groups")}
            on:keydown={(e) => e.key === "Enter" && navigate("/groups")}
            icon={faUsers}
          >
            <div class="label">
              {$_("common.groups")}
            </div>
          </MenuItem>
        {/if}

        {#if $isAuthorized("app_read")}
          <MenuItem
            selected={selected === "applications"}
            on:click={() => navigate("/applications")}
            on:keydown={(e) => e.key === "Enter" && navigate("/applications")}
            icon={faTh}
          >
            <div class="label">
              {$_("common.apps")}
            </div>
          </MenuItem>
        {/if}

        {#if $user.data.isMaster}
          <MenuItem
            selected={selected === "contracts"}
            on:click={() => navigateSvelte("/access-manager/admin/contracts")}
            on:keydown={(e) => e.key === "Enter" && navigateSvelte("/access-manager/admin/contracts")}
            icon={faHouse}
          >
            <div class="label">
              {$_("admin.contracts")}
            </div>
          </MenuItem>

          <MenuItem
            selected={selected === "globalApps"}
            on:click={() => navigateSvelte("/access-manager/admin/apps")}
            on:keydown={(e) => e.key === "Enter" && navigateSvelte("/access-manager/admin/apps")}
            icon={faTableRows}
          >
            <div class="label">
              {$_("admin.apps")}
            </div>
          </MenuItem>
        {/if}
      </Menu>
    </div>
  </div>

  <div class="p-6 content">
    <slot />
  </div>
</div>

<style>
  .flex-menu {
    width: 262px;
    background-color: var(--gl-background);
  }

  .menu {
    position: fixed;
    height: 100%;
    padding: 14px;
    width: 262px;
    z-index: 10;
    background-color: var(--gl-background);
  }

  .content {
    margin: 0 auto;
    width: 75%;
  }

  .main {
    height: 100%;
    display: flex;
  }

  @media screen and (max-width: 1300px) {
    .menu,
    .flex-menu {
      width: 70px;
      padding: 0;
    }

    .menu :global(.gl-icon) {
      margin: 0;
    }
    .menu :global(.gl-menu-item) {
      flex-direction: column;
      text-align: center;
    }

    .label {
      font-size: 10px;
    }
  }
</style>
